 import axios, { AxiosResponse, AxiosError } from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;

  export const updateNotificationTune = (
   tune:any,                
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`, 
      'Content-Type': 'application/json',
    };
    const payload = {
tune:tune
    
    };
    axios
      .put(`${global.api_url}/api/notification_tune`, payload, { headers })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data); 
        }
        else if(response.status === 201) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data); 
        } 
        else if (error.response?.status === 404) {
          _errorCallBack(error.response.data);
        }else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };